import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
})
export class AppToolbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
